import React, { useEffect } from "react";
// components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { MenuUsuario } from "../../Usuario/components/MenuUsuario";
import { Footer } from "../../../components/Landing/Footer";
// styled components
import { Tabs, Alert, Button } from "antd";
import MisPostulacionesJurado from "../Regiterform/MisPostulacionesJurado";
import "../Regiterform/styleCss.scss";
import { useInscribirHojaJurados } from "../../../hooks/useInscribirHojaJurados";
import { SubsanarDocumentos } from "./components/SubsanarDocumentos";
import EvaluacionProyectosList from "../Regiterform/EvaluacionProyectosList";
import EvaluacionHojasdeVidaList from "../Regiterform/EvaluacionHojasdeVidaList";
import EvaluacionProyectos from "../Regiterform/EvaluacionProyecto";

export const MenuJurado = () => {
  const {
    jurado,
    consultarJurado,
    messageNoJurado,
    errorConsultaJurado,
    lineasConvocatorias,
  } = useInscribirHojaJurados();

  useEffect(() => {
    consultarJurado();
  }, []);

  return (
    <div>
      <Header />
      <div className="container-fluid2" style={{ paddingTop: "1.5%", paddingBottom: "5%" }}>
        <div className="row">
          <MenuUsuario activeItem={1} />
          <div className="col-12 col-lg-10">
            <div className="row justify-content-center">
              <div className="col-12 font-size-14px font-family-Montserrat-Bold">
                <Tabs
                  className="height-100 col background-color-FFFFFF no margin"
                  defaultActiveKey="1"
                >
                  <Tabs.TabPane
                    tab="Mis Postulaciones"
                    key="1"
                    className="height-100 font-size-13px font-family-Montserrat-Regular"
                  >
                    <div className="row mt-4">
                      <div className="col-12 font-size-18px text-start font-family-Montserrat-Regular">
                        <span className="font-family-Montserrat-SemiBold">
                          Mi Información de Jurado.
                        </span>
                      </div>
                    </div>
                    <MisPostulacionesJurado />
                  </Tabs.TabPane>
                  <Tabs.TabPane
                    tab="Subsanar documentos"
                    key="2"
                    className="height-100 font-size-13px font-family-Montserrat-Regular"
                  >
                    <SubsanarDocumentos />
                  </Tabs.TabPane>
                  <Tabs.TabPane
                    tab="Evaluación proyectos"
                    key="3"
                    className="height-100 font-size-13px font-family-Montserrat-Regular"
                  >
                    {errorConsultaJurado ? (
                      <div className="pt-4">
                        <Alert
                          message="No se pudo consultar su información de jurado en este momento. Revise su conexión e intente de nuevo."
                          type="error"
                          action={
                            <Button size="small" type="primary" onClick={consultarJurado}>
                              Reintentar
                            </Button>
                          }
                        />
                      </div>
                    ) : messageNoJurado ? (
                      <div className="pt-4">
                        <Alert
                          message="Su documento no figura como jurado seleccionado. Si considera que es un error, comuníquese con la Secretaría de Cultura Ciudadana."
                          type="warning"
                        />
                      </div>
                    ) : (
                      <>
                        <EvaluacionProyectosList
                          jurado={jurado}
                          lineasConvocatorias={lineasConvocatorias}
                        />
                        <EvaluacionProyectos />
                      </>
                    )}
                  </Tabs.TabPane>
                  <Tabs.TabPane
                    tab="Evaluación Hojas de vida"
                    key="4"
                    className="height-100 font-size-13px font-family-Montserrat-Regular"
                  >
                    {errorConsultaJurado ? (
                      <div className="pt-4">
                        <Alert
                          message="No se pudo consultar su información de jurado en este momento. Revise su conexión e intente de nuevo."
                          type="error"
                          action={
                            <Button size="small" type="primary" onClick={consultarJurado}>
                              Reintentar
                            </Button>
                          }
                        />
                      </div>
                    ) : messageNoJurado ? (
                      <div className="pt-4">
                        <Alert
                          message="Su documento no figura como jurado seleccionado. Si considera que es un error, comuníquese con la Secretaría de Cultura Ciudadana."
                          type="warning"
                        />
                      </div>
                    ) : (
                      <EvaluacionHojasdeVidaList jurado={jurado} />
                    )}
                  </Tabs.TabPane>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
